
import React from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import CallToAction from '@/components/CallToAction';
import SEO from '@/components/SEO';
import ResidentialContactForm from '@/components/residential/ResidentialContactForm';

// Import refactored components
import HeroSection from './HeroSection';
import ServicesSection from './ServicesSection';
import ServicePlans from './ServicePlans';
import WhyChooseUs from './WhyChooseUs';
import FAQSection from './FAQSection';

const ResidentialServices: React.FC = () => {
  return (
    <div className="min-h-screen">
      <SEO 
        title="Residential IT Services - Home Computer Support & Network Solutions"
        description="Expert residential IT support services including computer repair, home network setup, security solutions, and tech troubleshooting for homeowners."
        canonicalUrl="https://itmgmtsol.com/services/residential"
      />
      <Navbar />
      
      {/* Hero Section */}
      <HeroSection />
      
      {/* Residential Services Section */}
      <ServicesSection />
      
      {/* Service Plans Section */}
      <ServicePlans />
      
      {/* Why Choose Us Section */}
      <WhyChooseUs />
      
      {/* FAQ Section */}
      <FAQSection />
      
      {/* CTA Section */}
      <CallToAction
        title="Ready to solve your home technology issues?"
        subtitle="Schedule a consultation with our residential IT experts today. We'll help you find the right solution for your needs."
        buttonText="Get Expert Help"
        buttonLink="#contact"
      />
      
      {/* Residential Contact Form Section */}
      <section id="contact">
        <ResidentialContactForm />
      </section>
      
      <Footer />
    </div>
  );
};

export default ResidentialServices;
